module.exports = __webpack_public_path__ + "img/borderGemstoneWhite.e493f473.svg";